import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { reportService } from "../../../Services/report.service";
import { downloadService } from "../../../Services/download.service";
import { TbReportAnalytics } from "react-icons/tb";
import { toDateTimeISOStringFormat } from "../../../Services/string.service";

export default function ReportDropDown(props) {
  const { vehicleSelected } = useSelector((state) => state.vehicleSelectedReducer);

  const [selectedOption, setSelectedOption] = useState("");
  const [disabled, setDisabled] = useState(props.loading);

  const reportOptions = [
    { label: "Excel", value: "XLSX" },
    { label: "PDF", value: "PDF" },
    { label: "KMZ", value: "KMZ" },
  ];

  useEffect(() => {
    setDisabled(props.loading);
  }, [props.loading]);

  const handleChange = async (e) => {
    const type = e.target.value;
    const normalizedType = type?.toLowerCase();
    if (!type) return;

    setSelectedOption(type);
    setDisabled(true);
    if (props.onToast) {
      props.onToast(
        JSON.stringify({
          show: true,
          title: "Atenção",
          body: "Processando relatório...",
          color: "Warning",
        })
      );
    }

    try {
      let result;

      // Convertendo datas para o formato esperado
      const startDate = props.startDate
        ? toDateTimeISOStringFormat(new Date(props.startDate)).replace("Z", "")
        : undefined;
      const endDate = props.endDate
        ? toDateTimeISOStringFormat(new Date(props.endDate)).replace("Z", "")
        : undefined;

      // Payload para os novos métodos de posições
      const positionsPayload = {
        VehicleId: props.vehicleId || vehicleSelected?.vehicleId,
        GroupId: props.groupId,
        StartDate: startDate,
        EndDate: endDate,
        OnlyEvents: "N",
      };

      // Chamando os novos métodos de posições baseado no tipo
      if (normalizedType === "pdf") {
        result = await reportService.fetchVehiclesPositionsPdf(positionsPayload);
      } else if (normalizedType === "xls" || normalizedType === "xlsx") {
        result = await reportService.fetchVehiclesPositionsXls(positionsPayload);
      } else if (normalizedType === "kmz") {
        result = await reportService.fetchVehiclesPositionsKmz(positionsPayload);
      } else {
        result = null;
      }

      if (!result || result.error) {
        if (props.onToast) {
          props.onToast(
            JSON.stringify({
              show: true,
              title: "Atenção",
              body: result?.message || "Não foi possível gerar o relatório ou não há dados.",
              color: "Danger",
            })
          );
        }
      } else {
        const downloaded = downloadService.downloadApiFile(
          result,
          normalizedType,
          "GridReport"
        );

        if (!downloaded) {
          downloadService.downloadBase64File(result, normalizedType, "GridReport");
        }

        if (props.onToast) {
          props.onToast(
            JSON.stringify({
              show: true,
              title: "Sucesso",
              body: "Relatório exportado.",
              color: "Success",
            })
          );
        }
      }
    } catch (err) {
      console.error(err);
      if (props.onToast) {
        props.onToast(
          JSON.stringify({
            show: true,
            title: "Erro",
            body: "Falha ao gerar relatório.",
            color: "Danger",
          })
        );
      }
    } finally {
      setDisabled(false);
      setSelectedOption(""); // Reset para placeholder
    }
  };

  return (
    <div className="filter">
      <div>
        <div className="icon-filter">
          <TbReportAnalytics/>
        </div>
        <span className="title">Relatórios</span>
      </div>

      <select
        className="filter-select"
        value={selectedOption}
        onChange={handleChange}
        disabled={disabled}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <option className="filter-option" value="">
          Selecionar
        </option>
        {reportOptions.map((opt) => (
          <option key={opt.value} className="filter-option" value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
